export const FINANCIAL_APPROVAL_GUIDE_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/resources?Id=0698W00000dyzKlQAI";
export const PROGRAM_ENGAGEMENT_NEW_ID_GUIDE_LINK =
  "https://amazon.awsapps.com/workdocs/index.html#/document/38ac9ddadbb6d024760b5810f025a67af75668db44413bcdc6b3ad2b423e0909";
export const PARTNER_FUNDING_BENEFIT_GUIDE_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/resources?keyword=AWS+Partner+Funding+Benefits+Guide";
export const MIGRATION_ASSESSMENT_REPORT_TEMPLATE_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/resources?Id=0698W0000104RklQAE";
export const MIGRATION_COMPLETION_REPORT_TEMPLATE_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/resources?Id=0698W0000104RkgQAE";
export const MANAGED_SERVICES_AGREEMENT_TEMPLATE_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/resources?Id=0698W0000105geQQAQ";
export const PARTNER_SCOPE_CHECKLIST_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/resources?categories=a1o8W00000UnCZpQAN";
export const MAP_CUSTOMER_SIGNOFF_TEMPLATE =
  "https://partnercentral.awspartner.com/partnercentral2/s/resources?categories=a1o8W00000UnCkwQAF";
export const MDF_INTRODUCTORY_RESOURCES_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/article?article=AWS-Partner-Central-and-AWS-account-linking-How-to-Get-Started&category=Introductory_resources";
export const MDF_SELF_EXTEND_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/article?article=How-To&category=Funding_Operations_and_Management#Extend-Start/End-Date";
export const FUNDING_BENEFITS_GUIDE_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/login?ec=302&startURL=%2Fpartnercentral2%2Fs%2Farticle%3Fcategory%3DFunding_Get_Started";
export const PARTNER_CENTRAL_MIGRATION_GUIDE =
  "https://partnercentral.awspartner.com/partnercentral2/s/article?category=Introductory_resources&article=Partner-Central-Migration-Guide";
export const FUNDING_POLICY_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/article?category=Funding_Get_Started&article=Policy";
export const PRM_REQUIREMENTS_LINK =
  "https://docs.aws.amazon.com/PRM/latest/aws-prm-onboarding-guide/what-is-service.html";
export const PRM_ATTRIBUTED_REVENUE_DASHBOARD_LINK =
  "https://us-east-1.console.aws.amazon.com/partnercentral/analytics/attributed-revenue?region=us-east-2";
export const APN_SUPPORT_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/support";
export const APFP_FINANCE_APPROVAL_GUIDE_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/article?category=Funding_Operations_and_Management&article=APFP-Finance-Approval-Guide";
export const PC2_MIGRATION_FAQ_LINK =
  "https://partnercentral.awspartner.com/partnercentral2/s/article?category=Introductory_resources&article=Partner-Central-Migration-Guide-FAQ";
